import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '../../../core';
import { takeUntil } from 'rxjs/operators';
import { interval } from 'rxjs';

export interface SuccessCheckAnimationDialogComponentData {
  text: string;
  textHtml?: string;
  countDowntimeMs?: number;
  showCountDownBar?: boolean;
}

@Component({
  selector: 'lib-success-check-animation-dialog',
  templateUrl: './success-check-animation-dialog.component.html',
  styleUrls: ['./success-check-animation-dialog.component.scss'],
})
export class SuccessCheckAnimationDialogComponent extends BaseComponent {
  public text: string;
  public textHtml: string;
  public showCountDownBar: boolean;
  public countDownBarProcess = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: SuccessCheckAnimationDialogComponentData,
    private dialogRef: MatDialogRef<SuccessCheckAnimationDialogComponent>
  ) {
    super();

    this.text = this.data?.text;
    this.textHtml = this.data?.textHtml;
    this.showCountDownBar = this.data?.showCountDownBar;

    const countDowntimeMs = this.data?.countDowntimeMs || 2000;

    this.startCountDownToCloseDialog(countDowntimeMs);
  }

  private startCountDownToCloseDialog(countDowntimeMs: number): void {
    const tickMs = countDowntimeMs / 100;

    setTimeout(() => this.dialogRef.close(), countDowntimeMs);

    interval(tickMs)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(() => {
        if (this.countDownBarProcess < 100) {
          this.countDownBarProcess += 1;
        }
      });
  }
}
